import { createReducer } from '@reduxjs/toolkit'
import { PromoPeriod } from 'interfaces/api/promoPeriods.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createPromoPeriod,
  getAllPromoPeriods,
  removePromoPeriod,
  setPromoPeriodValidationErrors,
  setSinglePromoPeriod,
  updatePromoPeriod,
} from './actions'

interface PromoPeriodsState {
  list: {
    loading: boolean
    items: PromoPeriod[]
  }
  single: {
    loading: boolean
    item: PromoPeriod | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: PromoPeriodsState = {
  list: {
    loading: false,
    items: [],
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const promoPeriodsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllPromoPeriods.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllPromoPeriods.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllPromoPeriods.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })

    .addCase(setPromoPeriodValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([setSinglePromoPeriod], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase([createPromoPeriod.pending, removePromoPeriod.pending, updatePromoPeriod.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createPromoPeriod.rejected, removePromoPeriod.rejected, updatePromoPeriod.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createPromoPeriod.fulfilled, removePromoPeriod.fulfilled, updatePromoPeriod.fulfilled], (state) => {
      state.single.loading = false
    })
})
